import { request } from '@meta-vue/util'
import { logBigResponse } from '@/util/tools'
import { getUserI18n } from '@/util/tools.js'

if (process.env.VUE_APP_DEBUG === 'memory') {
  console.log = () => {}
  console.warn = () => {}
  console.info = () => {}
}
export function beforeAppMount(app, { store }) {
  try {
    if (window._crm_handle_source_Error) {
      // 需要移除这个错误
      window.removeEventListener('error', window._crm_handle_source_Error, true)
      window._crm_handle_source_Error = null
    }

    if (window._crm_checkLoadedTimer) {
      // 移除这个定时器
      clearTimeout(window._crm_checkLoadedTimer)
      window._crm_checkLoadedTimer = null
    }
  } catch (error) {
    console.error('兜底一下', error)
  }

  // 检查萨德权限
  // try {
  //   // checkAndShowProtocol()
  // } catch (e) {
  //   console.error('检查萨德权限', e)
  // }

  //  清除localStorage缓存
  try {
    // 需要清理的本地缓存key
    const removeCacheKeys = ['$$local_/cust-complain-app/complainTypes/getTypesTree']
    removeCacheKeys.forEach(removeKey => {
      if (localStorage[removeKey]) localStorage.removeItem(removeKey)
    })
  } catch (error) {
    console.info(error, '清除本地缓存数据异常')
  }
  // localStorage缓存大小检查
  try {
    let total = 0
    const overKeys = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      const value = localStorage.getItem(key)
      const size = key.length + (value && value.length * 2) // Account for UTF-16 以字节为单位
      total += size
      if (size >= 1024 * 1024) {
        overKeys.push({
          key,
          size: size / 1024 / 1024
        })
      }
    }
    if (overKeys.length) {
      const windowLibTrack = window.lib && window.lib.track
      windowLibTrack.error('localStorage缓存大小超过1M', {
        track: {
          overKeys,
          total: total / 1024 / 1024
        },
        message: {
          overKeys,
          total: total / 1024 / 1024
        },
        type: 'localStorage-over1m'
      })
    }
  } catch (e) {
    console.error(e)
  }

  // 上报大数据响应体接口
  try {
    request.init({
      getResponse: logBigResponse,
      baseURL: process.env.VUE_APP_QMOVE,
      headers: {
        'User-I18n': getUserI18n()
      } // 每个请求要携带的头
    })
  } catch (e) {
    console.log(e)
  }
}
